import React, { useEffect, useState } from 'react';
import Html from './html';
import shared from './shared';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { Routes } from '../../methods/ApiRoutes';
import environment from '../../environment';
  import { toast } from "react-toastify";

function Transactions() {
  const [filters, setFilter] = useState({
    page: 1,
    count: 10,
    search: '',
    type: '',
    venueId: '',
    userId: '',
  });
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loaging, setLoader] = useState(false);
  const [venues, setVenues] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isExporting ,setIsExporting]= useState(false)

  useEffect(() => {
    getData();
    getVenues();
    getUsers();
  }, []);

  const getData = async (params = {}) => {
    loader(true);
    setLoader(true);
    const payload = {
      ...filters,
      ...params,
    };

    // Remove empty filters
    Object.keys(payload).forEach((key) => {
      if (payload[key] === '' || payload[key] === undefined || payload[key] === null)
        delete payload[key];
    });

    ApiClient.get(shared.listApi, payload).then((response) => {
      loader(false);
      setLoader(false);
      if (response?.success) {
        setData(response?.data || []);
        setTotal(response?.total || 0);
      } else {
        setData([]);
        setTotal(0);
      }
    });
  };

  const getVenues = () => {
    ApiClient.get(Routes.Venue.listApi, { page: 1, count: 1000, status: 'active' }).then(
      (res) => {
        if (res.success) {
          setVenues(res.data || []);
        }
      }
    );
  };

  const getUsers = (params = {}) => {

    const payload = {
      page: 1,
      count: 100,
      ...params,
    };

    ApiClient.get(Routes?.Transactions?.activeUsers, payload).then((res) => {
      console.log("API Response:", res);
      console.log("Users:", res.data);


      if (res.success) {

        setUsers(
          (res.data || []).map((item) => ({
            id: item.userDetail?._id,
            value: item.userDetail?._id,
            name: item.userDetail?.fullName,
            email: item.userDetail?.email,
          }))
        );

      } else {
        setUsers([]);
      }

    });

  };

  const sortClass = (key) => {
    let cls = 'fa-sort';
    if (filters.key === key && filters.sorder === 'asc') cls = 'fa-sort-up';
    else if (filters.key === key && filters.sorder === 'desc') cls = 'fa-sort-down';
    return `fa ${cls}`;
  };

  const sorting = (key) => {
    let sorder = 'asc';
    if (filters.key === key && filters.sorder === 'asc') sorder = 'desc';

    const updatedFilters = {
      ...filters,
      sortBy: `${key} ${sorder}`,
      key,
      sorder,
    };

    setFilter(updatedFilters);
    getData(updatedFilters);
  };

  const clear = () => {
    const f = {
      search: '',
      type: '',
      venueId: '',
      userId: '',
      page: 1,
    };
    const updated = { ...filters, ...f };
    setFilter(updated);
    getData(updated);
  };

  const filter = (p = {}) => {
    const updated = { ...filters, page: 1, ...p };
    setFilter(updated);
    getData(updated);
  };

  const pageChange = (e) => {
    const updated = { ...filters, page: e };
    setFilter(updated);
    getData(updated);
  };

  const count = (e) => {
    const updated = { ...filters, count: e, page: 1 };
    setFilter(updated);
    getData(updated);
  };

  const changeVenue = (venueId) => {

    filter({ venueId });

    getUsers({
      venueId,
      status: 'success'
    });

  };

  const changeUser = (userId) => {

    const updated = {
      ...filters,
      userId,
      page: 1,
    };

    setFilter(updated);

    getData(updated);
  };

  const changeType = (type) => {
    filter({ type });
  };

  const view = (id) => {
    const transaction = data.find((itm) => itm._id === id || itm.id === id);
    setSelectedTransaction(transaction);
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setSelectedTransaction(null);
  };
  const handleExport = async () => {
    setIsExporting((prev)=>!prev)
    let exportData;
    let newFilter = {}
    newFilter={...filters};
    delete newFilter.count;
    await ApiClient.get(shared.listApi, newFilter).then((response) => {
      if (response?.success) {  
        exportData=response?.data
        setIsExporting((prev)=>!prev)
      } else {
        setIsExporting(false)
      }
    });
    if (!exportData || exportData.length === 0){
      setIsExporting((prev)=>!prev)
      toast.error("No data to export")
      return ;
    }

    const headers = ['User Name', 'User Email', 'Venue', 'Type', 'Points', 'Status', 'Notes', 'Date'];
    const rows = exportData.map((row) => {
      const userName = row?.userDetail?.fullName || row?.userFullName || row?.fullName || '';
      const userEmail = row?.userDetail?.email || row?.userEmail || '';
      const venue = row?.venue?.name || row?.retailerCompanyName || row?.venueName || '';
      const type = row?.type || '';
      const points = row?.creditPoints || row?.redeemPoints || row?.points || 0;
      const status = row?.status || '';
      const notes = (row?.notes || row?.discription || '').replace(/"/g, '""');
      const date = row?.createdAt || row?.updatedAt || '';
      return [userName, userEmail, venue, type, points, status, `"${notes}"`, date].join(',');
    });

    const csv = [headers.join(','), ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Transactions_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <Html
      view={view}
      clear={clear}
      sortClass={sortClass}
      sorting={sorting}
      count={count}
      pageChange={pageChange}
      filters={filters}
      setFilter={setFilter}
      filter={filter}
      loaging={loaging}
      data={data}
      total={total}
      venues={venues}
      users={users}
      changeVenue={changeVenue}
      changeUser={changeUser}
      changeType={changeType}
      selectedTransaction={selectedTransaction}
      isModalVisible={isModalVisible}
      closeModal={closeModal}
      handleExport={handleExport}
      isExporting={isExporting}
      setIsExporting={setIsExporting}
    />
  );
}

export default Transactions;
